export default __webpack_public_path__ + "static/media/header-bg.2fa0facc.webp";